

    <template>
<div>
 <q-input outlined  v-model="myModelValue" @keyup="update" :label="props.label">
      <template v-slot:prepend>
        <q-icon name="event" class="cursor-pointer">
          <q-popup-proxy cover transition-show="scale" transition-hide="scale">
            <!-- <q-date v-model="myModelValue" mask="YYYY-MM-DD HH:mm"> -->
            <q-date v-model="myModelValue" mask="DD.MM.YYYY HH:mm">
              <div class="row items-center justify-end">
                <q-btn v-close-popup label="Close" color="primary" flat />
              </div>
            </q-date>
          </q-popup-proxy>
        </q-icon>
      </template>

      <template v-slot:append>
        <q-icon name="access_time" class="cursor-pointer">
          <q-popup-proxy cover transition-show="scale" transition-hide="scale">
            <q-time v-model="myModelValue" mask="DD.MM.YYYY HH:mm" format24h  @update:model-value="timeSelected">
              <div class="row items-center justify-end">
                <q-btn v-close-popup label="Close" color="primary" flat />
              </div>
            </q-time>
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>


</div>
</template>

<script setup>
import { ref,watch,inject } from "vue";
const moment = inject("moment")
const emit = defineEmits( ["update:modelValue"])
const props = defineProps( {
  modelValue: String,
  label: String,
})
// const myModelValue = ref(moment(props.modelValue).format("YYYY-MM-DD HH:mm"))
console.log("props.modelValue"+props.modelValue)

const myModelValue = ref(null)
if(typeof(props.modelValue)!="undefined"){
   myModelValue.value = moment(props.modelValue).format("DD.MM.YYYY HH:mm")

}

function timeSelected(date){

  console.log("timselected",date)

}
watch(
  () => myModelValue.value,
  () => {
    emit("update:modelValue", moment(myModelValue.value,"DD.MM.YYYY HH:mm").toISOString());
  }
);

function update() {
  console.log("update")
  emit("update:modelValue", myModelValue.value);
}

</script>
